const nonEmptyText = (value) => (typeof value === "string" && value.trim() ? value.trim() : "");
export const MODULE_ACCESS_DENIED = "You don't have access to this module.";

export const isPermissionDenied = (body) => body?.error?.code === "permission_denied"
  || body?.code === "permission_denied";

// Redux Toolkit stamps these transport-level placeholders onto rejected
// actions. They are not user-facing copy and must never reach an alert.
const transportPlaceholders = new Set(["Rejected", "Aborted"]);

const readableTransportMessage = (value) => {
  const text = nonEmptyText(value);
  return transportPlaceholders.has(text) ? "" : text;
};

const fieldResolutionText = (fields) => {
  if (!fields || typeof fields !== "object" || Array.isArray(fields)) return [];

  return Object.entries(fields).flatMap(([field, messages]) => {
    const values = Array.isArray(messages) ? messages : [messages];
    const label = field.replace(/[_-]+/g, " ").replace(/^./, (character) => character.toUpperCase());
    return values
      .map(nonEmptyText)
      .filter(Boolean)
      .map((message) => `${label}: ${message}`);
  });
};

const structuredMessage = (value) => {
  if (!value || typeof value !== "object" || Array.isArray(value)) return [];

  const reason = [
    value.userMessage,
    value.error && value.error.message,
    value.message,
  ].map(nonEmptyText).find(Boolean);
  const fields = fieldResolutionText(
    value.fields || (value.error && value.error.fields),
  );

  return [reason, ...fields].filter(Boolean);
};

export const contentErrorMessage = (action, fallback = "Unable to load content.") => {
  const payload = action && action.payload;
  const body = payload && payload.message;
  if (isPermissionDenied(payload) || isPermissionDenied(body)) return MODULE_ACCESS_DENIED;
  const payloadParts = [
    nonEmptyText(payload && payload.userMessage),
    ...structuredMessage(payload),
    ...structuredMessage(body),
    nonEmptyText(payload),
  ].filter(Boolean);
  const transportMessage = readableTransportMessage(action && action.error && action.error.message);

  if (payloadParts.length > 0) return [...new Set(payloadParts)].join(" ");
  return transportMessage || fallback;
};
